import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';

import heroBanner from '../assets/images/hero-images/web & app Development.webp';
import heroMobile from '../assets/images/mobile-banners/development-mobile.webp';
import ecommerceImg from '../assets/images/webp-images/eccomerce.44944b05.webp';
import frontendImg from '../assets/images/frontend.jfif';
import backendImg from '../assets/images/backend.jpg';
import mobileImg from '../assets/images/mobile.jpg';
import offerImg from '../assets/images/100USD.png';

import devTab1 from '../assets/images/develop-tabs/1.png';
import devTabWeb from '../assets/images/develop-tabs/Web-Devep.20c7c61e.png';
import devTabMobile from '../assets/images/develop-tabs/Mobile-Apps.4bb59397.png';

import discoveryCard from '../assets/images/develop-design-cards/Discovery.png';
import uiuxCard from '../assets/images/develop-design-cards/UIUX.png';
import agileCard from '../assets/images/develop-design-cards/Agile.png';
import cicdCard from '../assets/images/develop-design-cards/CICD.png';

import jsIcon from '../assets/images/web-service-cards/javascript.695f5796.png';
import cmsIcon from '../assets/images/web-service-cards/cms.b74d70c5.png';
import ecomIcon from '../assets/images/web-service-cards/eccomerce.fc325140.png';
import frameworkIcon from '../assets/images/web-service-cards/framework.57cd9806.png';
import phpIcon from '../assets/images/web-service-cards/php.27659f20.png';
import apiIcon from '../assets/images/web-service-cards/API.png';

import client1 from '../assets/images/develop-logo-icons/client1.684c440e.avif';
import client2 from '../assets/images/develop-logo-icons/client2.225fef63.avif';
import client3 from '../assets/images/develop-logo-icons/client3.39c5ba0e.avif';
import client4 from '../assets/images/develop-logo-icons/client4.1bd9785d.avif';
import phpLogo from '../assets/images/develop-logo-icons/php.png';
import djangoLogo from '../assets/images/develop-logo-icons/django.png';
import shopifyLogo from '../assets/images/develop-logo-icons/shopify.png';

const devTabs = [
  { id:'design', label:'WEB DESIGN', img:devTab1, title:'User-Centric Interfaces that Convert.', content:'We craft pixel-perfect, mobile-first interfaces. Our UI/UX process ensures your brand communicates clearly, builds trust instantly, and guides users to take action. Every element is purposeful.' },
  { id:'dev',    label:'WEB DEVELOPMENT', img:devTabWeb, title:'Robust, Scalable, and Secure Code.', content:'We build full-stack applications using the right technology for your project — whether that is a PHP/Laravel backend, a Node.js API, or a Python microservice. Clean code. Clean architecture.' },
  { id:'mobile', label:'MOBILE APPS', img:devTabMobile, title:'Native & Cross-Platform Excellence.', content:'Extend your business to every pocket. We develop high-performance mobile apps for iOS and Android using React Native and Flutter, ensuring a native feel without native cost.' },
];

const workflowCards = [
  { step:'STEP 01', title:'Discovery', desc:'We analyse your business goals, user personas, and technical constraints to define a solid project foundation and roadmap.' },
  { step:'STEP 02', title:'Design', desc:'Wireframes to full Figma prototypes — we validate the UX before a single line of code is written.' },
  { step:'STEP 03', title:'Development', desc:'Agile sprints, daily builds, and automated testing keep delivery fast and quality high.' },
  { step:'STEP 04', title:'Launch', desc:'We deploy to production via CI/CD pipelines and monitor your infrastructure from day one.' },
];

const techStack = [
  { img:frontendImg, title:'Frontend', items:['React / Vue / Angular','HTML5 + CSS3','Tailwind CSS','TypeScript'] },
  { img:backendImg,  title:'Backend',  items:['Node.js / Express','PHP / Laravel','Python / Django','Java / Spring Boot'] },
  { img:mobileImg,   title:'Mobile',   items:['React Native','Flutter','iOS (Swift)','Android (Kotlin)'] },
];

const caseHighlights = [
  { tag:'Pakistan — FinTech', title:'FinTech Platform', desc:'Built a high-security payment processing portal for a leading Pakistani FinTech. Integrated real-time fraud detection and PCI-DSS-compliant data flows.' },
  { tag:'Australia — Retail', title:'E-Commerce Automation', desc:'Developed a headless WooCommerce solution with automated inventory syncing across 3 warehouses. Reduced order processing time by 70%.' },
  { tag:'Europe — SaaS', title:'Enterprise Dashboard', desc:'Architected a multi-tenant SaaS dashboard with role-based access control. Reduced client onboarding time from weeks to minutes.' },
];

const agileCards = [
  { img:discoveryCard, step:'PHASE 01', title:'Discovery & Strategy', desc:'Before writing a line of code, we deeply understand your business goal, map out the user journeys, select the right technology stack, and produce a clear development timeline.' },
  { img:uiuxCard,      step:'PHASE 02', title:'UI / UX Design', desc:'We prototype your interface in Figma and validate it with real users. You see and interact with the product before it is built — eliminating costly mid-development changes.' },
  { img:agileCard,     step:'PHASE 03', title:'Agile Development', desc:'We build in 2-week sprint cycles. Working software is delivered every fortnight, allowing you to give feedback early and often, catching issues fast without compromising stability.' },
  { img:cicdCard,      step:'PHASE 04', title:'CI / CD Deployment', desc:'Code is automatically tested, built, and deployed on every commit. We set up complete pipeline automation so your team can ship features multiple times per day, safely.' },
];

const expertiseSlide1 = [
  { img:jsIcon,  title:'FULL STACK JS', desc:'Modern & Reactive: We build SPAs using Angular, React, and Vue.js. On the backend, we leverage Node.js and Express for fast, event-driven architectures.' },
  { img:cmsIcon, title:'CMS DEVELOPMENT', desc:'Secure & Scalable: Custom, high-performance sites using WordPress, Joomla, and Drupal. Our focus is security hardening and core web vitals for SEO.' },
  { img:ecomIcon,title:'E-COMMERCE', desc:'Conversion Focused: WooCommerce, Magento, or Shopify — we customize the shopping experience and ensure your checkout is secure and inventory syncs in real-time.' },
];
const expertiseSlide2 = [
  { img:frameworkIcon, title:'MVC FRAMEWORKS', desc:'Structured Code: Laravel (PHP), Django (Python), and Spring Boot (Java) for enterprise applications that are maintainable, secure, and scalable.' },
  { img:phpIcon, title:'CORE PHP', desc:'The Web Engine: PHP powers 70% of the web. We write clean, optimized PHP code for legacy maintenance or modern object-oriented systems.' },
  { img:apiIcon, title:'API INTEGRATION', desc:'Connected Ecosystems: RESTful and GraphQL APIs connecting your apps with payment gateways, CRMs, and third-party services with secure authentication.' },
];

const secondLogos = [client1,client2,client3,client4,phpLogo,djangoLogo,shopifyLogo];

const devPlans = [
  { title:'BUILD AND', highlight:'DEPLOY', best:'IT Teams & Agencies', tagline:'We build it, we launch it, you manage it.', btn:'Start Project',
    items:['✅ Custom Development','✅ CI/CD Deployment Setup','✅ Source Code Handover','✅ Basic Documentation','❌ Managed Hosting (Operations)','❌ 3-Month Warranty','❌ Annual Service Contract'] },
  { title:'BUILD AND', highlight:'SUPPORT', best:'SMBs & Startups', tagline:'We build it and ensure it runs perfectly for the first quarter.', btn:'Start Project',
    items:['✅ Custom Development','✅ CI/CD Deployment Setup','✅ Source Code Handover','✅ Standard Maintenance','❌ Managed Hosting (Operations)','✅ 3-Month Warranty','❌ Annual Service Contract'] },
  { title:'BUILD AND', highlight:'OPERATE', best:'Enterprises & Scaling Apps', tagline:'We build, host, and evolve your app.', btn:'Partner With Us',
    items:['✅ Custom Development','✅ CI/CD Deployment Setup','✅ Full Source Code Access','✅ Proactive Maintenance','✅ Managed Hosting (Operations)','✅ 3-Month Warranty Included','✅ Annual Service Contract'] },
];

function DevelopmentServices() {
  const [activeTab, setActiveTab] = useState('design');
  const [expertiseSlide, setExpertiseSlide] = useState(0);
  const expertiseSlides = [expertiseSlide1, expertiseSlide2];

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* HERO */}
      <section style={{ marginTop:'125px' }}>
        <div className="container-fluid p-0">
          <img src={heroBanner} width="1600" height="520" alt="Web & App Development" className="img-fluid w-100 d-none d-md-block" />
          <img src={heroMobile} width="768" height="1000" alt="Web & App Development" className="img-fluid w-100 d-md-none d-block" />
        </div>
      </section>

      {/* TABS */}
      <section id="tab-section" className="my-5">
        <div className="container text-center">
          <h1 className="text-center top-line txt-color mt-5 fw-semibold" style={{ textTransform:'capitalize' }}>From Concept to Cloud</h1>
          <h1 className="text-center my-3 text-muted" style={{ textTransform:'capitalize' }}>Full-Cycle Product Engineering.</h1>
        </div>
        <div className="container w-75 my-5 custom-tab-container">
          <ul className="nav nav-tabs justify-content-center" role="tablist">
            {devTabs.map(t => (
              <li className="nav-item" key={t.id}>
                <button className={`nav-link ${activeTab===t.id?'active':''}`} onClick={() => setActiveTab(t.id)} type="button">{t.label}</button>
              </li>
            ))}
          </ul>
          <div className="tab-content p-3">
            {devTabs.map(t => (
              <div key={t.id} className={`tab-pane fade ${activeTab===t.id?'show active':''}`}>
                <div className="row align-items-center" style={{ minHeight:'350px' }}>
                  <div className="col-lg-6">
                    <h3 className="fw-semibold">{t.title}</h3>
                    <p>{t.content}</p>
                    <Link to="/contact" className="btn btn-info text-white mt-2">Start a Project</Link>
                  </div>
                  <div className="col-lg-6 text-center">
                    <img src={t.img} loading="lazy" alt={t.label} className="img-fluid mx-auto" style={{ maxWidth:'90%' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AGILE WORKFLOW */}
      <section className="py-5 bg-light position-relative">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">The DevOps Agile Workflow</h2>
          </div>
          <div className="row g-4">
            {workflowCards.map((c,i) => (
              <div className="col-md-6 col-lg-3" key={i} data-aos="fade-up" data-aos-delay={i*100}>
                <div className="workflow-card h-100">
                  <div className="step mb-2">{c.step}</div>
                  <h5>{c.title}</h5>
                  <p className="text-muted small">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TECH STACK */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold text-primary">Our Technology Stack</h2>
          </div>
          <div className="row g-4 text-center">
            {techStack.map((s,i) => (
              <div className="col-md-4" key={i} data-aos="fade-up" data-aos-delay={i*100}>
                <div className="tech-card h-100">
                  <img src={s.img} alt={s.title} className="mb-3 mx-auto floating-icon d-block" style={{ height:'80px', objectFit:'cover', width:'80px', borderRadius:'8px' }} />
                  <h5 className="fw-bold">{s.title}</h5>
                  <ul className="list-unstyled mt-3">
                    {s.items.map((item,j) => <li key={j} className="mb-1 text-muted">{item}</li>)}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CASE HIGHLIGHTS */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Recent Work & Case Highlights</h2>
          </div>
          <div className="row g-4">
            {caseHighlights.map((c,i) => (
              <div className="col-md-4" key={i} data-aos="fade-up" data-aos-delay={i*100}>
                <div className="case-card h-100">
                  <span>{c.tag}</span>
                  <h5>{c.title}</h5>
                  <p className="text-muted small">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AGILE LIFECYCLE */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <span className="section-tag">HOW WE WORK</span>
            <h2 className="fw-bold mt-2">THE AGILE LIFECYCLE</h2>
            <p className="text-muted">A DevOps-driven process designed for speed, stability, and scalability.</p>
          </div>
          <div className="row g-4">
            {agileCards.map((c,i) => (
              <div className="col-md-6 col-lg-3" key={i} data-aos="fade-up" data-aos-delay={i*100}>
                <div className="agile-card h-100">
                  <img src={c.img} alt={c.title} className="img-fluid mb-3" style={{ height:'80px', objectFit:'contain' }} />
                  <span className="step">{c.step}</span>
                  <h5>{c.title}</h5>
                  <p>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* E-COMMERCE */}
      <section style={{ margin:'3rem auto' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="top-line fs-1">High-Performance <span className="txt-color">E-Commerce</span></h2>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-12">
              <p data-aos="fade-right" style={{ textAlign:'justify' }}>
                DDevOps transforms online stores into revenue engines. We help startups launch fast and established brands scale effortlessly. Unlike traditional agencies, we integrate <b>DevOps methodologies (CI/CD)</b> directly into your store's architecture. This means you can roll out new features instantly without downtime, handle massive traffic spikes during sales events, and enjoy enterprise-grade security. We ensure your store is always fast, always online, and always converting.
              </p>
            </div>
            <div className="col-md-6 col-sm-12 text-center">
              <img src={ecommerceImg} alt="e-commerce" className="img-fluid" data-aos="fade-left" />
            </div>
          </div>
        </div>
      </section>

      {/* EVERYONE SECTION */}
      <section className="everyone-section position-relative d-flex justify-content-start align-items-center my-5">
        <div className="everyone-img container-fluid d-flex justify-content-center align-items-center">
          <div className="p-5 container rounded-4 shadow-sm" style={{ backgroundColor:'rgba(240,248,255,0.92)' }} data-aos="fade-up" data-aos-delay="300">
            <h2 className="text-start mt-2 mb-3">Let's Get <span className="txt-color">Everyone Online</span></h2>
            <p className="fs-5 fw-medium">Reliable, Responsive & Progressive Websites. Fully Managed.</p>
            <p className="mt-3 w-50">
              DDevOps is committed to digital inclusion. We support communities, startups, and small businesses by removing the barrier to entry. We deliver a complete, high-performance WordPress solution that helps you connect with the world—without breaking the bank.
            </p>
            <ul className="list-unstyled mt-4">
              <li className="mb-2">✅ Premium WordPress Setup</li>
              <li className="mb-2">✅ Mobile Responsive Design</li>
              <li className="mb-2">✅ 1 Year Hosting & Maintenance</li>
            </ul>
            <p className="text-muted mb-4">Development + 1 Year Operation Included</p>
          </div>
          <img src={offerImg} className="special-offer-png" alt="Special offer" />
        </div>
      </section>

      {/* DEVELOPMENT PLANS */}
      <section className="my-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="top-line fw-bold">Development <span className="txt-color">Plans</span></h2>
          </div>
          <div className="row g-4">
            {devPlans.map((plan,i) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={i} data-aos="fade-up" data-aos-delay={i*100}>
                <div className="card p-4 shadow-sm h-100 text-center">
                  <h5 className="fw-bold">{plan.title} <span className="txt-color">{plan.highlight}</span></h5>
                  <p className="mb-2 text-muted">Best For: <strong>{plan.best}</strong></p>
                  <p className="small text-muted mb-3">{plan.tagline}</p>
                  <Link to="/contact" className="btn btn-info text-white mb-4">{plan.btn}</Link>
                  <ul className="list-unstyled text-start mx-auto" style={{ maxWidth:'270px' }}>
                    {plan.items.map((item,j) => <li className="mb-2" key={j}>{item}</li>)}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* OUR EXPERTISE */}
      <section className="second-logo-slider bg-light py-3">
        <div className="container my-5">
          <div className="text-center mb-5">
            <h1 className="fw-bold mb-2">OUR <span className="txt-color">EXPERTISE</span></h1>
            <p className="text-muted fs-5">Mastering the technologies that power the modern web.</p>
          </div>

          {/* Expertise Cards */}
          <div id="expertiseCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
            <div className="carousel-inner py-4 px-3">
              {[expertiseSlide1, expertiseSlide2].map((slide, si) => (
                <div className={`carousel-item ${si===0?'active':''}`} key={si}>
                  <div className="row justify-content-center g-4">
                    {slide.map((card,ci) => (
                      <div className="col-12 col-md-6 col-lg-4" key={ci}>
                        <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                          <img src={card.img} className="mx-auto mb-3" style={{ height:'70px' }} alt={card.title} />
                          <h5 className="fw-bold mb-2">{card.title}</h5>
                          <p className="text-muted" style={{ fontSize:'0.95rem' }}>{card.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button className="btn btn-outline-primary" type="button" data-bs-target="#expertiseCarousel" data-bs-slide="prev">Prev</button>
              <button className="btn btn-outline-primary" type="button" data-bs-target="#expertiseCarousel" data-bs-slide="next">Next</button>
            </div>
          </div>

          {/* Logo Track */}
          <div className="second-logo-wrapper mt-5">
            <h3 className="text-center fw-bold text-dark mb-4 mt-5 d-block">
              <span className="px-3 py-2">Tools & Technologies We Master</span>
            </h3>
            <div className="second-logo-track d-flex align-items-center">
              {[...secondLogos, ...secondLogos].map((logo,i) => (
                <img key={i} src={logo} className="second-slide-logo-img" alt={`Tech ${i}`} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default DevelopmentServices;
